import React from 'react';
import {Platform, TouchableOpacity, View, Text} from 'react-native';
import {buttonsStyles} from '../Button/boutonStyle';
import {formsStyles} from '../Inputs/formStyles';
import Label from '../Label';
import {styles} from './styles';

interface FooterProps {
  creerCompte?: () => void;
  connectAction?: () => void;
  isInscription?: boolean;
}

export const Footer = ({
  creerCompte,
  connectAction,
  isInscription = false,
} : FooterProps) => {

  return (
    <View>
    {isInscription ? 
      (
        <View style={styles.container}>
            <Text>Déjà membre ? </Text>
            <TouchableOpacity
                onPress={connectAction}>
                <Label title=' Se connecter' type="linkUnderline" />
            </TouchableOpacity>
        </View>
      ) : (
        <View>
      {Platform.OS === 'ios' ? (
        <View>
          <View style={[buttonsStyles.displaySpacedBtween]}>
            <Label
              title="Si vous n'avez pas encore de compte "
              type="paragraph"
            />
            <View style={formsStyles.line} />
          </View>

          <View style={[buttonsStyles.displayHorizontal]}>
            <TouchableOpacity onPress={creerCompte}>
              <Label title="Créer un compte" type="linkblue" />
            </TouchableOpacity>
          </View>
        </View>
      ) : (
        <View>
          <View
            style={[
              buttonsStyles.displayCenterLoginBottom,
              styles.buttonContainer,
            ]}>
            <View style={buttonsStyles.displaySpacedBtween}>
              <View>
                <Label
                  title="Si vous n'avez pas encore de compte "
                  type="paragraph"
                />
              </View>
              <View style={formsStyles.line} />
            </View>
          </View>
          <View
            style={[
              buttonsStyles.displayCenterLoginBottom,
              styles.buttonContainer,
              styles.content,
            ]}>
            <View style={[buttonsStyles.displayHorizontal]}>
              <TouchableOpacity onPress={creerCompte}>
                <Label title="Créer un compte" type="linkblue" />
              </TouchableOpacity>
            </View>
          </View>
        </View>
      )}
    </View>
      )
    }
    </View>
  );
};
